import { render } from "./SortView.vue?vue&type=template&id=505517db"
import script from "./SortView.vue?vue&type=script&lang=js"
export * from "./SortView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__